import {CInput, CInvalidFeedback, CLabel, CTextarea} from '@coreui/react';
import React from "react";
import { useField } from 'formik';

export const Input = ({label, ...props}) => {
    const [field, meta] = useField(props);
    return (
        <>
            {label && <CLabel htmlFor={props.id || props.name}>{label}</CLabel>}
            <CInput {...field} {...props} invalid={Boolean(meta.error)} />
            {meta.error ? (
                <CInvalidFeedback>{meta.error}</CInvalidFeedback>
            ) : null}
        </>
    );
};

export const Textarea = ({label, ...props}) => {
    const [field, meta] = useField(props);
    return (
        <>
            {label && <CLabel htmlFor={props.id || props.name}>{label}</CLabel>}
            <CTextarea {...field} {...props} invalid={Boolean(meta.error)} />
            {meta.error ? (
                <CInvalidFeedback>{meta.error}</CInvalidFeedback>
            ) : null}
        </>
    );
};